'use client';

import { useCallback, useSyncExternalStore } from 'react';

/**
 * Devuelve el nodo con ese `id`, o `null` si todavía no existe.
 *
 * Los huecos de portal los monta el shell, que puede pintarse después que la
 * vista. Un `getElementById` suelto devolvería `null` una vez y nunca se
 * enteraría de que el nodo apareció; el observer vuelve a preguntar cuando el DOM
 * cambia. Es el mecanismo que ya usaba el portal del topbar, generalizado para
 * que el carril derecho no lo duplique.
 */
export function usePortalTarget(id: string) {
	const subscribe = useCallback((onStoreChange: () => void) => {
		if (typeof document === 'undefined' || typeof MutationObserver === 'undefined' || !document.body) {
			return () => {};
		}
		const observer = new MutationObserver(onStoreChange);
		observer.observe(document.body, { childList: true, subtree: true });
		return () => observer.disconnect();
	}, []);

	const getSnapshot = useCallback(
		() => (typeof document === 'undefined' ? null : document.getElementById(id)),
		[id],
	);

	return useSyncExternalStore(subscribe, getSnapshot, () => null);
}
